import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from './types';

export const getters = {
    [OVERVIEW_PANEL_GET_CURRENT]: state => {
        return state.current;
    },
    [OVERVIEW_PANEL_IS_VISIBLE]: state => {
        return state.visible;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/overview-panel/getters.js